import localstorageTTL from "localstorage-ttl";
import React from "react";
import { Redirect, Route } from "react-router-dom";

export const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      localstorageTTL.get("globalStorage") ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname:
              rest.path.indexOf("pwa") >= 0 ? "/pwa/login" : "/nr/login",
            state: { from: props.location },
          }}
        />
      )
    }
  />
);
